(() => {
  if (window.__rylPrimaryNavigationLoaded) return;
  window.__rylPrimaryNavigationLoaded = true;

  const initialize = () => {
    document.querySelectorAll('[data-ryl-primary-nav-mobile]').forEach((menu) => {
      const label = menu.querySelector('[data-ryl-primary-nav-toggle-label]');
      const closeButton = menu.querySelector('[data-ryl-primary-nav-close]');

      const close = () => {
        menu.open = false;
        if (label) label.textContent = 'Open main menu';
      };

      menu.addEventListener('toggle', () => {
        if (label) label.textContent = menu.open ? 'Close main menu' : 'Open main menu';
      });

      menu.querySelectorAll('.ryl-primary-nav__link').forEach((link) => {
        link.addEventListener('click', close);
      });

      closeButton?.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-ryl-primary-nav-mobile][open]').forEach((menu) => {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
